import React, {Fragment} from 'react';
import clsx from 'clsx';
import PropTypes, {InferType} from 'prop-types';
import {
    Collapse,
    Grid,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import {Generate} from 'commons/utils/Functions';
import {ModuleItem} from 'commons/types/Types';
import {ModuleShape} from 'commons/shapes/flow/Flow';
import {MenuItemStyles} from 'assets/tss/layouts/components';
import {getIcon} from 'layouts/commons/sidebar/utils/Utils';

function MenuItem(props: InferType<typeof MenuItem.propTypes>) {
    const {module, active, open, handleChildClick} = props;
    const classes = MenuItemStyles();
    function renderItemIcon(icon: string) {
        return <ListItemIcon>{getIcon(icon)}</ListItemIcon>;
    }

    function renderExpandIcon(flag: boolean) {
        if (flag) {
            return <ExpandLessIcon />;
        } else {
            return <ExpandMoreIcon color={'primary'} />;
        }
    }

    function renderTag(title: string, expandIcon: boolean, icon: string | undefined, variant: any) {
        return (
            <Fragment>
                {icon && 'no-icon' !== icon && renderItemIcon(icon)}
                <ListItemText>
                    <Typography variant={variant}>{title}</Typography>
                </ListItemText>
                {expandIcon && renderExpandIcon(open)}
            </Fragment>
        );
    }

    function renderChilds(items: Array<ModuleItem>) {
        return (
            <Collapse in={open} timeout='auto' unmountOnExit>
                {items.map((item: ModuleItem) => {
                    const hasChilds = item.items && item.items.length > 0;
                    return (
                        <Fragment key={`collapse-menu-item-${Generate.uniqueID()}`}>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                key={`grid-menu-item-${Generate.uniqueID()}`}>
                                <List
                                    component={'div'}
                                    disablePadding
                                    className={clsx(
                                        active === `${item.viewId}`
                                            ? classes.menuItemSelected
                                            : classes.menuItemNested
                                    )}
                                    key={`menu-item-${Generate.uniqueID()}`}>
                                    <ListItem
                                        button
                                        selected={active === `${item.viewId}`}
                                        onClick={(event: React.SyntheticEvent) => {
                                            event.stopPropagation();
                                            handleChildClick(item, true);
                                        }}
                                        className={clsx(
                                            active === `${item.viewId}`
                                                ? classes.menuItemSelected
                                                : classes.menuItemNested
                                        )}>
                                        {!item.thirdLevel &&
                                            renderTag(
                                                item.name,
                                                hasChilds || false,
                                                item.icon,
                                                'body2'
                                            )}
                                    </ListItem>
                                </List>
                            </Grid>
                            {item.thirdLevel &&
                                item &&
                                renderElement(item, 'body1', item.thirdLevel)}
                        </Fragment>
                    );
                })}
            </Collapse>
        );
    }

    function renderElement(element: ModuleItem, variant: any, thirdLevel?: boolean) {
        const hasChilds = element.items && element.items.length > 0;
        return (
            <Fragment>
                <Grid item xs={12} sm={12} md={12} key={`element-${element.title}`}>
                    <ListItem
                        button
                        disableGutters
                        selected={open}
                        className={clsx(thirdLevel ? classes.menuItemSubmodule : classes.menuItem)}>
                        {renderTag(element.name, hasChilds || false, element.icon, variant)}
                    </ListItem>
                </Grid>
                {element.items && element.items.length ? renderChilds(element.items) : null}
            </Fragment>
        );
    }

    return (
        <Grid container direction={'row'} key={Generate.uniqueID('grid')}>
            {module && renderElement(module, 'body1')}
        </Grid>
    );
}

MenuItem.propTypes = {
    module: ModuleShape.isRequired,
    active: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    handleChildClick: PropTypes.func,
};

export default MenuItem;
